export const GET_COMPANY_USERS_SUCCESS = 'importist/dashboard/account/GET_COMPANY_USERS_SUCCESS';



// WEBPACK FOOTER //
// ./src/container/dashboard/AccountContainer/constants.js